





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import SearchInput from "@/components/SearchInput.vue";
import BackButton from "@/components/BackButton.vue";
import CategoryListCard from "@/components/Admin/CategoryListCard.vue";
import CategoryModal from "@/components/Admin/CategoryModal.vue";

import { categoryService } from "@/services/category.service";
import { Category } from '@/models/category.model';


@Component({
    components : {
        SearchInput,
        BackButton,
        CategoryListCard,
        CategoryModal
    }
})
export default class AdminPinBoard extends Vue{
    filterWeek:boolean = true;
    filterMonth:boolean = false;
    isModalVisible:boolean = false;
    categories:Category[] = [];
    categoryId:number = 0;
    searchQuery:string = "";

    async created(){
        this.load();
    }

    async load(){
        this.categories = await categoryService.getAll(this.$store.getters["app/companyId"]);
    }

    edit(id:number){
        this.categoryId = id;
        this.isModalVisible = true;
    }

    async remove(id:number){
        var r = confirm("Vill du ta bort denna?");
        if (r == true) {
            categoryService.delete(id).then(() => {
                this.load();
                this.$notify({
                    group: 'message',
                    title: 'Succe!',
                    text: 'Kategori borttaget',
                    duration: 5000,
                    type: 'success',
                });
            });
        }
    }

    get filteredList(){
        let filterList = this.categories;
        if(this.searchQuery != "" && this.searchQuery.length > 1){
            filterList = filterList.filter(c => c.name!.toLowerCase().startsWith(this.searchQuery.toLowerCase()));
        }

        return filterList;
    }

    openModal(){
        this.categoryId = 0;
        this.isModalVisible = true;
    }

    modalEvent(obj:any,id:any){
        this.categoryId = id != undefined ? id : this.categoryId;
        this.isModalVisible = obj == "close" || obj == "saved" ? false : true;
        
        if(obj="saved")
            this.load();
    }


    
}
